import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { api } from '../../utils/api';

const STATUS_COLORS = { aprovado:'#0FA36B', pendente:'#F59E0B', nao_verificado:'#9095A8' };
const STATUS_LABELS = { aprovado:'Aprovado', pendente:'Pendente', nao_verificado:'Não verificado' };

const Badge = ({ status }) => (
  <span style={{
    background: STATUS_COLORS[status] + '22',
    color: STATUS_COLORS[status] || '#9095A8',
    fontSize:11, fontWeight:600, padding:'3px 10px', borderRadius:99,
  }}>{STATUS_LABELS[status] || status}</span>
);

export default function FornecedoresList() {
  const { token } = useAuth();
  const navigate = useNavigate();
  const [lista, setLista] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtros, setFiltros] = useState({ busca:'', segmento:'', status:'' });
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({
    empresa:'', pais:'China', cidade:'', estado:'', tipo:'Fabricante',
    status:'nao_verificado', segmento:'', principais_produtos:'',
    atacado_real:false, aceita_oem:false, aceita_private_label:false,
    email:'', telefone:'', site:'', wechat:'', observacoes:'', fonte:''
  });
  const [salvando, setSalvando] = useState(false);
  const segmentos = [...new Set(lista.map(f=>f.segmento).filter(Boolean))].sort();

  const carregar = () => {
    const params = new URLSearchParams();
    if (filtros.busca) params.set('busca', filtros.busca);
    if (filtros.segmento) params.set('segmento', filtros.segmento);
    if (filtros.status) params.set('status', filtros.status);
    api.get(`/fornecedores?${params}`, token)
      .then(setLista)
      .catch(console.error)
      .finally(() => setLoading(false));
  };

  useEffect(() => { carregar(); }, [filtros, token]);

  const salvar = async () => {
    if (!form.empresa) return alert('Nome da empresa é obrigatório');
    setSalvando(true);
    try {
      await api.post('/fornecedores', form, token);
      setShowModal(false);
      setForm({ empresa:'', pais:'China', cidade:'', estado:'', tipo:'Fabricante', status:'nao_verificado', segmento:'', principais_produtos:'', atacado_real:false, aceita_oem:false, aceita_private_label:false, email:'', telefone:'', site:'', wechat:'', observacoes:'', fonte:'' });
      carregar();
    } catch(e) { alert('Erro ao salvar'); }
    setSalvando(false);
  };

  const exportar = async () => {
    const res = await fetch(`${process.env.REACT_APP_API_URL || ''}/api/fornecedores?limit=9999`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    const data = await res.json();
    const rows = [['Empresa','País','Cidade','Estado','Tipo','Status','Segmento','Produtos','Email','Telefone','Site','WeChat','Observações']];
    data.forEach(f => rows.push([f.empresa,f.pais,f.cidade,f.estado,f.tipo,f.status,f.segmento,f.principais_produtos,f.email,f.telefone,f.site,f.wechat,f.observacoes]));
    const csv = rows.map(r => r.map(c => `"${(c||'').replace(/"/g,'""')}"`).join(',')).join('\n');
    const blob = new Blob([csv], { type:'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = 'fornecedores.csv'; a.click();
  };

  const inp = (field, value) => setForm(f => ({ ...f, [field]: value }));

  return (
    <div style={{padding:32,maxWidth:1100,margin:'0 auto'}}>
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:24}}>
        <div>
          <h1 style={{fontSize:20,fontWeight:700,color:'#0B0E1A',margin:0}}>Fornecedores</h1>
          <p style={{fontSize:13,color:'#9095A8',margin:'4px 0 0'}}>{lista.length} resultado(s)</p>
        </div>
        <div style={{display:'flex',gap:10}}>
          <button onClick={exportar} style={{background:'#fff',color:'#3D4461',border:'1px solid #E2E4ED',borderRadius:8,padding:'9px 18px',fontSize:13,fontWeight:600,cursor:'pointer'}}>Exportar</button>
          <button onClick={() => setShowModal(true)} style={{background:'#1A2ECC',color:'#fff',border:'none',borderRadius:8,padding:'9px 18px',fontSize:13,fontWeight:600,cursor:'pointer'}}>+ Novo fornecedor</button>
        </div>
      </div>

      {/* Filtros */}
      <div style={{display:'flex',gap:10,marginBottom:20,flexWrap:'wrap'}}>
        <input placeholder="Buscar por empresa, produto..." value={filtros.busca}
          onChange={e => setFiltros(f=>({...f,busca:e.target.value}))}
          style={{flex:1,minWidth:220,padding:'9px 14px',border:'1px solid #E2E4ED',borderRadius:8,fontSize:13,outline:'none'}} />
        <select value={filtros.segmento} onChange={e => setFiltros(f=>({...f,segmento:e.target.value}))}
          style={{padding:'9px 14px',border:'1px solid #E2E4ED',borderRadius:8,fontSize:13,outline:'none',background:'#fff'}}>
          <option value="">Segmento: todos</option>
          {[...new Set(lista.map(f=>f.segmento).filter(Boolean))].map(s=><option key={s} value={s}>{s}</option>)}
        </select>
        <select value={filtros.status} onChange={e => setFiltros(f=>({...f,status:e.target.value}))}
          style={{padding:'9px 14px',border:'1px solid #E2E4ED',borderRadius:8,fontSize:13,outline:'none',background:'#fff'}}>
          <option value="">Status: todos</option>
          <option value="aprovado">Aprovado</option>
          <option value="pendente">Pendente</option>
          <option value="nao_verificado">Não verificado</option>
        </select>
      </div>

      {/* Tabela */}
      <div style={{background:'#fff',borderRadius:12,boxShadow:'0 1px 4px rgba(0,0,0,.06)',overflow:'hidden'}}>
        <table style={{width:'100%',borderCollapse:'collapse'}}>
          <thead>
            <tr style={{borderBottom:'1px solid #F4F5F9'}}>
              {['Empresa','Localização','Segmento','Produtos','Tipo','Status',''].map(h=>(
                <th key={h} style={{padding:'12px 16px',textAlign:'left',fontSize:11,fontWeight:600,color:'#9095A8',textTransform:'uppercase',letterSpacing:'.06em'}}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={7} style={{padding:24,textAlign:'center',color:'#9095A8',fontSize:13}}>Carregando...</td></tr>}
            {!loading && lista.length === 0 && (
              <tr><td colSpan={7} style={{padding:32,textAlign:'center',color:'#9095A8',fontSize:13}}>Nenhum fornecedor cadastrado. Clique em "Novo fornecedor" para começar.</td></tr>
            )}
            {lista.map(f => (
              <tr key={f.id} style={{borderBottom:'1px solid #F4F5F9',transition:'.1s'}} onMouseEnter={e=>e.currentTarget.style.background='#F9FAFB'} onMouseLeave={e=>e.currentTarget.style.background=''}>
                <td style={{padding:'14px 16px'}}>
                  <div style={{fontSize:13,fontWeight:600,color:'#0B0E1A'}}>{f.empresa}</div>
                </td>
                <td style={{padding:'14px 16px',fontSize:12,color:'#6B7289'}}>
                  {[f.cidade, f.estado, f.pais].filter(Boolean).join(' · ')}
                </td>
                <td style={{padding:'14px 16px',fontSize:12,color:'#6B7289'}}>{f.segmento || '—'}</td>
                <td style={{padding:'14px 16px',fontSize:12,color:'#6B7289',maxWidth:180}}>
                  <div style={{overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{f.principais_produtos || '—'}</div>
                </td>
                <td style={{padding:'14px 16px',fontSize:12,color:'#6B7289'}}>{f.tipo || '—'}</td>
                <td style={{padding:'14px 16px'}}><Badge status={f.status} /></td>
                <td style={{padding:'14px 16px'}}>
                  <button onClick={() => navigate(`/mentor/fornecedores/${f.id}`)}
                    style={{background:'#EEF1FF',color:'#1A2ECC',border:'none',borderRadius:6,padding:'6px 14px',fontSize:12,fontWeight:600,cursor:'pointer'}}>
                    Ver
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Modal Novo Fornecedor */}
      {showModal && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.4)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000}}>
          <div style={{background:'#fff',borderRadius:16,padding:32,width:560,maxHeight:'85vh',overflowY:'auto',boxShadow:'0 8px 40px rgba(0,0,0,.15)'}}>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:24}}>
              <h2 style={{margin:0,fontSize:17,fontWeight:700,color:'#0B0E1A'}}>Novo Fornecedor</h2>
              <button onClick={() => setShowModal(false)} style={{background:'none',border:'none',fontSize:20,cursor:'pointer',color:'#9095A8'}}>×</button>
            </div>

            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:14}}>
              {[
                {label:'Empresa *',field:'empresa',full:true},
                {label:'País',field:'pais'},
                {label:'Cidade',field:'cidade'},
                {label:'Estado / Província',field:'estado'},
                {label:'Segmento / Nicho',field:'segmento',datalist:true},
                {label:'Principais produtos',field:'principais_produtos',full:true},
                {label:'E-mail',field:'email'},
                {label:'Telefone',field:'telefone'},
                {label:'Site',field:'site'},
                {label:'WeChat',field:'wechat'},
                {label:'Fonte (Canton Fair, Alibaba...)',field:'fonte',full:true},
                {label:'Observações',field:'observacoes',full:true,textarea:true},
              ].map(({label,field,full,textarea,datalist}) => (
                <div key={field} style={{gridColumn:full?'1/-1':'auto'}}>
                  <label style={{fontSize:11,fontWeight:600,color:'#6B7289',display:'block',marginBottom:4}}>{label}</label>
                  {textarea
                    ? <textarea value={form[field]} onChange={e=>inp(field,e.target.value)} rows={3}
                        style={{width:'100%',padding:'9px 12px',border:'1px solid #E2E4ED',borderRadius:8,fontSize:13,outline:'none',resize:'vertical',boxSizing:'border-box'}} />
                    : datalist
                    ? <><input value={form[field]} onChange={e=>inp(field,e.target.value)} list={`dl-${field}`} placeholder="Digite ou escolha um existente" style={{width:'100%',padding:'9px 12px',border:'1px solid #E2E4ED',borderRadius:8,fontSize:13,outline:'none',boxSizing:'border-box'}} /><datalist id={`dl-${field}`}>{segmentos.map(s => <option key={s} value={s} />)}</datalist></>
                    : <input value={form[field]} onChange={e=>inp(field,e.target.value)}
                        style={{width:'100%',padding:'9px 12px',border:'1px solid #E2E4ED',borderRadius:8,fontSize:13,outline:'none',boxSizing:'border-box'}} />
                  }
                </div>
              ))}

              <div style={{gridColumn:'1/-1'}}>
                <label style={{fontSize:11,fontWeight:600,color:'#6B7289',display:'block',marginBottom:8}}>Tipo</label>
                <select value={form.tipo} onChange={e=>inp('tipo',e.target.value)}
                  style={{width:'100%',padding:'9px 12px',border:'1px solid #E2E4ED',borderRadius:8,fontSize:13,outline:'none'}}>
                  {['Fabricante','Distribuidor','Trading','Atacadista'].map(t=><option key={t} value={t}>{t}</option>)}
                </select>
              </div>

              <div style={{gridColumn:'1/-1'}}>
                <label style={{fontSize:11,fontWeight:600,color:'#6B7289',display:'block',marginBottom:8}}>Status</label>
                <select value={form.status} onChange={e=>inp('status',e.target.value)}
                  style={{width:'100%',padding:'9px 12px',border:'1px solid #E2E4ED',borderRadius:8,fontSize:13,outline:'none'}}>
                  <option value="nao_verificado">Não verificado</option>
                  <option value="pendente">Pendente</option>
                  <option value="aprovado">Aprovado</option>
                </select>
              </div>

              <div style={{gridColumn:'1/-1',display:'flex',gap:20}}>
                {[['atacado_real','Atacado real'],['aceita_oem','Aceita OEM'],['aceita_private_label','Aceita Private Label']].map(([f,l])=>(
                  <label key={f} style={{display:'flex',alignItems:'center',gap:6,fontSize:13,color:'#3D4461',cursor:'pointer'}}>
                    <input type="checkbox" checked={form[f]} onChange={e=>inp(f,e.target.checked)} />
                    {l}
                  </label>
                ))}
              </div>
            </div>

            <div style={{display:'flex',gap:10,marginTop:24,justifyContent:'flex-end'}}>
              <button onClick={() => setShowModal(false)} style={{background:'#F4F5F9',color:'#3D4461',border:'none',borderRadius:8,padding:'10px 20px',fontSize:13,fontWeight:600,cursor:'pointer'}}>Cancelar</button>
              <button onClick={salvar} disabled={salvando} style={{background:'#1A2ECC',color:'#fff',border:'none',borderRadius:8,padding:'10px 20px',fontSize:13,fontWeight:600,cursor:'pointer',opacity:salvando?.6:1}}>
                {salvando ? 'Salvando...' : 'Salvar fornecedor'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
